export type ManagerPackageComponent = 'api' | 'web' | 'desktop';

export const managerPackageComponents: Array<ManagerPackageComponent> = ['api', 'web', 'desktop'];

export const managerPackageComponentLabels: Record<ManagerPackageComponent, string> = {
    api: 'API',
    web: 'Web',
    desktop: 'Desktop',
};
